import { DataSummary } from "src/components/Reports/DataSummary/DataSummary"
import { useFetchGuestMessagesCountAnalytics } from "src/data/guestAnalytics/guestAnalyticsQueries"
import { useOrganization } from "src/data/organizations/hooks/useOrganization"
import { useTranslate } from "src/i18n/useTranslate"

export function AiAssistantAnalyticsSummaryCard({
  startDate,
  endDate,
}: {
  startDate: string
  endDate: string
}) {
  const { t, langKeys, tPlaceholder } = useTranslate()
  const { orgId } = useOrganization()

  const fetchGuestMessagesCountAnalytics = useFetchGuestMessagesCountAnalytics({
    orgId,
    filters: {
      from: startDate,
      to: endDate,
    },
  })

  const isLoading = fetchGuestMessagesCountAnalytics.isLoading
  const isError = fetchGuestMessagesCountAnalytics.isError

  const totalMessages =
    fetchGuestMessagesCountAnalytics.data?.total_messages_count ?? 0

  const aiResolvedCount =
    fetchGuestMessagesCountAnalytics.data?.ai_resolved_count ?? 0

  const escalatedCount =
    fetchGuestMessagesCountAnalytics.data?.escalated_count ?? 0

  const resolvedRatio = Math.round((aiResolvedCount / totalMessages) * 100)
  const escalatedRatio = Math.round((escalatedCount / totalMessages) * 100)

  return (
    <DataSummary
      title={t(langKeys.summary)}
      isLoading={isLoading}
      isError={isError}
      data={[
        {
          value: totalMessages,
          description: tPlaceholder("Total messages"),
        },
        {
          value: `${resolvedRatio}%`,
          description: tPlaceholder("Resolved by AI Assistant"),
        },
        {
          value: `${escalatedRatio}%`,
          description: tPlaceholder("Escalated to team"),
        },
      ]}
    />
  )
}
